import { CreateWholesalerBillStatement, UpdateWholesalerBillStatement } from "../dtos";
import { GetManyWholesalerRecordQuery } from "../dtos/GetManyWholesalerRecordQuery";
import { WholesalerBillStatement } from "../dtos/WholesalerBillStatement";
import { BaseEndpoint } from "./BaseEndpoint";
import { Page } from "./domain";
import { WithCreate } from "./mixins/WithCreate";
import { WithDelete } from "./mixins/WithDelete";
import { WithGet } from "./mixins/WithGet";
import { WithUpdate } from "./mixins/WithUpdate";

export class Endpoint extends BaseEndpoint("wholesaler-bill-statements") {
  getRecords(
    wholesaler: string,
    query: GetManyWholesalerRecordQuery,
  ): Promise<Page<WholesalerBillStatement["records"]>> {
    return this.request(`${wholesaler}/records`, { query });
  }

  getStatements(wholesaler: string, query: GetManyWholesalerRecordQuery): Promise<Page<WholesalerBillStatement>> {
    return this.request(`${wholesaler}/statements`, { query });
  }
}

const withGet = WithGet<typeof Endpoint, WholesalerBillStatement>(Endpoint);
const withCreate = WithCreate<typeof withGet, WholesalerBillStatement, CreateWholesalerBillStatement>(withGet);
const withUpdate = WithUpdate<typeof withCreate, WholesalerBillStatement, UpdateWholesalerBillStatement>(withCreate);

export const WholesalerBillStatementEndpoint = WithDelete(withUpdate);
